import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
import DatePicker from "react-multi-date-picker";
import moment from "moment";
import { apiRequest } from "../../apiServices/allApi";

const OtpReport = () => {
  const [report, setReport] = useState([]);
  const [totalOtpUsed, setTotalOtpUsed] = useState(0);

  const [limit, setLimit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);

  // ================= DATE =================

  const Year = new Date().getFullYear();
  const Month = new Date().getMonth() + 1;

  const formattedMonth = Month < 10 ? `0${Month}` : `${Month}`;

  const StartDate = `${Year}/${formattedMonth}/01`;
  const EndDate = `${Year}/${formattedMonth}/31`;

  const [startDate, setStartDate] = useState(StartDate);
  const [endDate, setEndDate] = useState(EndDate);

  // ================= SEARCH =================

  const [searchList, setSearchList] = useState("");
  const [searchType, setSearchType] = useState("Phone");

  // ================= PAGE LIMIT =================

  const setpageLimit = (event) => {
    setLimit(Number(event.target.value));
    setPageNumber(1);
  };

  // ================= SEARCH =================

  const searchHandler = (event) => {
    setSearchList(event.target.value);
    setPageNumber(1);
  };

  // ================= PAGE =================

  const handlePageClick = (data) => {
    const currentPage = data.selected + 1;
    setPageNumber(currentPage);
  };

  // ================= DATE =================

  const handleStartDateChange = (date) => {
    const formattedDate = moment(date?.toDate?.() || date).format("YYYY-MM-DD");

    setStartDate(formattedDate);
    setPageNumber(1);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date?.toDate?.() || date).format("YYYY-MM-DD");

    setEndDate(formattedDate);
    setPageNumber(1);
  };

  // ================= GET OTP REPORT =================

  const getOtpReport = async () => {
    const access_token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const body = {
        page: pageNumber,
        _limit: limit,
        _q: searchList,
        FROM_DATE: startDate,
        TO_DATE: endDate,
      };

      const res = await apiRequest("admin/otp-report", "POST", body, headers);

      if (res?.data?.status) {
        setReport(res.data.data || []);
        setTotalOtpUsed(res.data.totalOtpUsed || 0);
        setNumberOfPages(res.data.totalPages || 0);
      } else {
        setReport([]);
        setTotalOtpUsed(0);
        setNumberOfPages(0);
      }
    } catch (error) {
      console.log("OTP Report Error:", error);

      setReport([]);
      setTotalOtpUsed(0);
      setNumberOfPages(0);
    }
  };

  useEffect(() => {
    getOtpReport();
  }, [pageNumber, limit, startDate, endDate, searchList, searchType]);

  // ================= DATE FORMAT =================

  const dateFormat = (date) => {
    if (!date) return "";

    return moment(date).format("DD-MM-YYYY");
  };

  // ================= EXPORT =================

  const handleExport = () => {
    const tableData = [
      {
        A: "Date",
        B: "OTP Used",
      },
    ];

    report.forEach((row) => {
      tableData.push({
        A: dateFormat(row.date),
        B: row.otpUsed || 0,
      });
    });

    // Total
    tableData.push({
      A: "Total OTP",
      B: totalOtpUsed,
    });

    const ws = XLSX.utils.json_to_sheet(tableData, {
      skipHeader: true,
    });

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "OTP Report");

    XLSX.writeFile(wb, "OTPReport.xlsx");
  };

  return (
    <>
      <div className="row mt-5">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body text-light table_bg">
              {/* ================= HEADING ================= */}

              <h3 className="d-flex flex-row dashboard_heading">OTP Reports</h3>

              {/* ================= TOTAL OTP ================= */}

              <div className="row mb-3">
                <div className="col-md-3">
                  <div
                    className="card"
                    style={{
                      background: "#fff",
                      borderRadius: "8px",
                    }}
                  >
                    <div className="card-body">
                      <h6 className="text-dark mb-2">Total OTP Used</h6>

                      <h3 className="text-primary mb-0">{totalOtpUsed}</h3>
                    </div>
                  </div>
                </div>
              </div>

              {/* ================= FILTER ================= */}

              <div className="row mb-4">
                {/* LIMIT */}

                <div className="col-md-2 col-sm-12">
                  <select
                    className="form-control"
                    id="pagelimit"
                    name="pagelimit"
                    value={limit}
                    onChange={setpageLimit}
                  >
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    <option value="2000">2000</option>
                  </select>
                </div>

                {/* SEARCH TYPE */}

                <div className="col-md-2 col-sm-12">
                  <select
                    className="form-control"
                    id="searchType"
                    name="searchtype"
                    value={searchType}
                    onChange={(e) => {
                      setSearchType(e.target.value);
                      setPageNumber(1);
                    }}
                  >
                    <option value="Phone">Phone</option>

                    <option value="_id">User Id</option>
                  </select>
                </div>

                {/* SEARCH */}

                <div className="col-md-2 col-sm-12">
                  <input
                    type="text"
                    placeholder="Search..."
                    className="form-control"
                    value={searchList}
                    onChange={searchHandler}
                  />
                </div>

                {/* DATE */}

                <div className="col-md-4 col-sm-12">
                  <div className="d-flex">
                    <DatePicker
                      value={startDate}
                      onChange={handleStartDateChange}
                      placeholder="Start Date"
                      format="YYYY-MM-DD"
                      style={{
                        height: "36px",
                      }}
                    />

                    <h4 className="text-dark m-2">To</h4>

                    <DatePicker
                      value={endDate}
                      onChange={handleEndDateChange}
                      placeholder="End Date"
                      format="YYYY-MM-DD"
                      minDate={startDate}
                      style={{
                        height: "36px",
                      }}
                    />
                  </div>
                </div>

                {/* EXPORT */}

                <div className="col-md-2 col-sm-12">
                  <button
                    onClick={handleExport}
                    className="btn btn-primary sm-ml-0 ml-4"
                    style={{
                      height: "40px",
                    }}
                  >
                    Export Data
                  </button>
                </div>
              </div>

              {/* ================= TABLE ================= */}

              <div className="table-responsive">
                <table className="table text-light">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>OTP Used</th>
                    </tr>
                  </thead>

                  <tbody>
                    {report && report.length > 0 ? (
                      report.map((data, key) => (
                        <tr key={key}>
                          <td>{(pageNumber - 1) * limit + key + 1}</td>

                          <td>{dateFormat(data.date)}</td>

                          <td>
                            <span className="font-weight-bold">
                              {data.otpUsed || 0}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No OTP Report Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* ================= PAGINATION ================= */}

              <div className="mt-4">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  forcePage={pageNumber - 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtpReport;
